"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcStepperBehavior = exports.ThemeCircles = void 0;
var helpers_1 = require("../../../common/helpers");
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_stepper_constants_1 = require("./bc-stepper-constants");
var bc_stepper_constants_2 = require("./bc-stepper-constants");
var bc_stepper_constants_3 = require("./bc-stepper-constants");
var bc_stepper_constants_4 = require("./bc-stepper-constants");
var bc_stepper_constants_5 = require("./bc-stepper-constants");
var bc_stepper_constants_6 = require("./bc-stepper-constants");
var bc_stepper_constants_7 = require("./bc-stepper-constants");
var bc_stepper_constants_8 = require("./bc-stepper-constants");
var bc_stepper_constants_9 = require("./bc-stepper-constants");
var bc_stepper_constants_10 = require("./bc-stepper-constants");
var bc_stepper_constants_11 = require("./bc-stepper-constants");
var bc_stepper_constants_12 = require("./bc-stepper-constants");
var bc_stepper_constants_13 = require("./bc-stepper-constants");
var bc_stepper_constants_14 = require("./bc-stepper-constants");
var ThemeCircles;
(function (ThemeCircles) {
    ThemeCircles[ThemeCircles["LIGHT"] = 0] = "LIGHT";
    ThemeCircles[ThemeCircles["DARK"] = 1] = "DARK";
})(ThemeCircles || (exports.ThemeCircles = ThemeCircles = {}));
var BcStepperBehavior = (function (_super) {
    __extends(BcStepperBehavior, _super);
    function BcStepperBehavior() {
        var _this = _super.call(this) || this;
        _this.maxStep = 0;
        _this.currentStep = 0;
        _this.initialStep = 0;
        _this.progressHeader = 0;
        _this.status = [];
        _this.labels = [];
        _this.isTop = false;
        _this.themeCircles = ThemeCircles.DARK;
        return _this;
    }
    BcStepperBehavior.prototype._setUp = function () {
        this._createSteppertrack();
        this.initTopHeader();
        this.isMobile = this._checkCurrentWidth();
        this._createBulletSteps();
        this.addClickEvent();
        this.addClickEventHeader();
        this._addResizeEvent();
        this._getElement();
        this.setInitState();
        this.setIndexStatus();
        this._setBulletStatus();
        this._checkStepperDirection();
        this._accessibility();
        this.scrollEventHeader();
        this.togleStepper();
    };
    BcStepperBehavior.prototype.togleStepper = function () {
        if (this.isMobile) {
            var headerRightElement = this.mySelf.querySelector(".".concat(bc_stepper_constants_12.STEPPER_HEADER_RIGHT));
            if (headerRightElement) {
                var customClickEvent = new Event(common_constants_1.BcCommonConstants.EVENT_CLICK);
                headerRightElement.dispatchEvent(customClickEvent);
            }
        }
    };
    BcStepperBehavior.prototype.setThemeCircles = function (themeCircles) {
        this.themeCircles = themeCircles;
    };
    BcStepperBehavior.prototype.initTopHeader = function () {
        if (!!this.mySelf.getAttribute(bc_stepper_constants_1.STEPPER_ATTR_TOP_HEADER)) {
            this.topHeader = Number(this.mySelf.getAttribute(bc_stepper_constants_1.STEPPER_ATTR_TOP_HEADER));
            this._setTopHeader();
        }
        else {
            this.mySelf.style.top = "0px";
        }
    };
    BcStepperBehavior.prototype._createSteppertrack = function () {
        var isStepperTrack = this.mySelf.querySelector(".".concat(bc_stepper_constants_2.STEPPER_PROGRESS_TRACK));
        if (!isStepperTrack) {
            var divTrack = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            divTrack.classList.add(bc_stepper_constants_2.STEPPER_PROGRESS_TRACK);
            this.mySelf.appendChild(divTrack);
        }
    };
    BcStepperBehavior.prototype._setTopHeader = function () {
        if (window.innerWidth <= bc_stepper_constants_11.STEPPER_RESOLUTION_MOBILE) {
            this.mySelf.style.top = "".concat(this.topHeader, "px");
        }
        else {
            this.mySelf.style.removeProperty('top');
        }
    };
    BcStepperBehavior.prototype.setDirection = function () {
        if (this.mySelf.classList.contains(bc_stepper_constants_1.STEPPER_VERTICAL)) {
            this.direction = bc_stepper_constants_8.STEPPER_VERTICAL_DIRECTION;
        }
        else {
            this.direction = bc_stepper_constants_8.STEPPER_HORIZONTAL_DIRECTION;
        }
        this._checkStepperDirection();
    };
    BcStepperBehavior.prototype.setNumStep = function (numSteps) {
        this.numSteps = numSteps;
        this.maxStep = numSteps;
        if (this.direction === bc_stepper_constants_8.STEPPER_HORIZONTAL_DIRECTION) {
            this.setProgressHorizontal();
        }
        else {
            this.setProgressVertical();
        }
    };
    BcStepperBehavior.prototype.setProgressHorizontal = function () {
        this.width = bc_stepper_constants_9.STEPPER_N100 / (this.numSteps - 1);
    };
    BcStepperBehavior.prototype.setProgressVertical = function () {
        this.height = bc_stepper_constants_9.STEPPER_N100 / (this.numSteps - 1);
    };
    BcStepperBehavior.prototype.setLabels = function (labels) {
        this.setDirection();
        this.labels = labels;
        this.setNumStep(this.labels.length);
    };
    BcStepperBehavior.prototype._getElement = function () {
        this.progressStepArray = Array.from(this.mySelf.querySelectorAll(".".concat(bc_stepper_constants_2.STEPPER_PROGRESS_STEP)));
        this.progressBulletArray = Array.from(this.mySelf.querySelectorAll(".".concat(bc_stepper_constants_3.STEPPER_INNER_BULLET)));
        this.progressTrack = this.mySelf.querySelector(".".concat(bc_stepper_constants_2.STEPPER_PROGRESS_TRACK));
    };
    BcStepperBehavior.prototype.setInitIndexPosition = function (index) {
        if (index >= 0 && index < this.labels.length) {
            this._setCurrentStep(index);
        }
    };
    BcStepperBehavior.prototype.setInitState = function () {
        this.status[this.currentStep] = bc_stepper_constants_7.STEPPER_IS_ACTIVE;
        this._setProgressHeader();
    };
    BcStepperBehavior.prototype.eventClickBullet = function (index, event) {
        var target = event.target;
        var isStatus = target.classList.contains(bc_stepper_constants_5.STEPPER_STATUS);
        var isIcon = target.classList.contains(common_constants_1.BcCommonConstants.ICONS_CLASS);
        if (isIcon || isStatus || this.checkIsBullet(target) || this.checkIsBulledVertical(target)) {
            if (index < this.currentStep) {
                for (var i = index; i <= this.currentStep; i++) {
                    this.status[i] = bc_stepper_constants_7.STEPPER_IS_DEFAULT;
                }
                this.status[index] = bc_stepper_constants_7.STEPPER_IS_ACTIVE;
                this._setCurrentStep(index);
                this._setBulletStatus();
                this._setProgressHeader();
                this._setCurrentStepHeader();
            }
            if (index > this.currentStep) {
                for (var i = this.currentStep; i <= index; i++) {
                    this.status[i] = bc_stepper_constants_7.STEPPER_IS_COMPLETE;
                }
                this.status[index] = bc_stepper_constants_7.STEPPER_IS_ACTIVE;
                this._setCurrentStep(index);
                this._setBulletStatus();
                this._setProgressHeader();
                this._setCurrentStepHeader();
            }
        }
    };
    BcStepperBehavior.prototype.checkIsBullet = function (target) {
        if (target.classList.contains(bc_stepper_constants_4.STEPPER_INNER_BULLET_ACTIVE)) {
            return target.previousElementSibling.classList.contains(bc_stepper_constants_6.STEPPER_DEFAULT_STEP);
        }
        return false;
    };
    BcStepperBehavior.prototype.checkIsBulledVertical = function (target) {
        var _a, _b;
        if ((_a = target.querySelector(".".concat(bc_stepper_constants_3.STEPPER_INNER_BULLET))) === null || _a === void 0 ? void 0 : _a.classList.contains(bc_stepper_constants_6.STEPPER_DEFAULT_STEP)) {
            return true;
        }
        if ((_b = target.querySelector(".".concat(bc_stepper_constants_3.STEPPER_INNER_BULLET))) === null || _b === void 0 ? void 0 : _b.classList.contains(bc_stepper_constants_6.STEPPER_COMPLETE_STEP)) {
            return true;
        }
        return false;
    };
    BcStepperBehavior.prototype.addClickEvent = function () {
        var _this = this;
        this.mySelf.querySelectorAll(".".concat(bc_stepper_constants_2.STEPPER_PROGRESS_STEP)).forEach(function (element, index) {
            element.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                _this.eventClickBullet(index, event);
            });
        });
    };
    BcStepperBehavior.prototype._addResizeEvent = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, function () {
            if (!!_this.topHeader) {
                _this._setTopHeader();
            }
            else {
                _this.mySelf.style.top = "0px";
            }
            _this._checkStepperDirection();
        });
    };
    BcStepperBehavior.prototype._checkStepperDirection = function () {
        this.isMobile = this._checkCurrentWidth();
        if (this.isMobile && this.mySelf.classList.contains("".concat(bc_stepper_constants_1.STEPPER_HORIZONTAL))) {
            this.mySelf.classList.remove("".concat(bc_stepper_constants_1.STEPPER_HORIZONTAL));
            this.mySelf.classList.add("".concat(bc_stepper_constants_1.STEPPER_VERTICAL));
        }
        else if (!this.isMobile &&
            this.direction === bc_stepper_constants_8.STEPPER_HORIZONTAL_DIRECTION &&
            this.mySelf.classList.contains("".concat(bc_stepper_constants_1.STEPPER_VERTICAL))) {
            this.mySelf.classList.remove("".concat(bc_stepper_constants_1.STEPPER_VERTICAL));
            this.mySelf.classList.add("".concat(bc_stepper_constants_1.STEPPER_HORIZONTAL));
            var elements = this.mySelf.querySelectorAll("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_stepper_constants_2.STEPPER_PROGRESS_STEP));
            elements.forEach(function (e) { return e.setAttribute(common_constants_1.BcCommonConstants.TABINDEX, bc_stepper_constants_10.STEPPER_N0); });
        }
    };
    BcStepperBehavior.prototype.setValue = function (value) {
        var currentState = this._getCurrentState();
        var diference = value - currentState;
        if (diference > 0) {
            for (var i = 0; i < diference; i++) {
                this.next();
            }
        }
        else {
            for (var i = 0; i < diference * -1; i++) {
                this.back();
            }
        }
    };
    BcStepperBehavior.prototype._checkCurrentWidth = function () {
        var isMobile = common_constants_1.BcCommonConstants.FALSE;
        if (window.innerWidth <= bc_stepper_constants_11.STEPPER_RESOLUTION_MOBILE) {
            isMobile = common_constants_1.BcCommonConstants.TRUE;
        }
        return isMobile;
    };
    BcStepperBehavior.prototype._createBulletSteps = function () {
        this.mySelf.classList.add(bc_stepper_constants_12.STEPPER_NAME);
        this.mySelf.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, bc_stepper_constants_11.STEPPER_TRUE);
        var bulletChild = document.createElement(common_constants_1.BcCommonConstants.HEADER_TAG);
        bulletChild.classList.add(bc_stepper_constants_12.STEPPER_HEADER);
        bulletChild.appendChild(this._createBulletStepsHeaderLeft());
        bulletChild.appendChild(this._createBulletStepsHeaderCenter());
        bulletChild.appendChild(this._createBulletStepsHeaderRight());
        this.mySelf.appendChild(bulletChild);
        this.settingAtributes();
    };
    BcStepperBehavior.prototype._createBulletStepsHeaderLeft = function () {
        var divLeft = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divLeft.classList.add("".concat(bc_stepper_constants_5.STEPPER_HEADER_LEFT));
        divLeft.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABELLEDBY, "".concat(bc_stepper_constants_12.STEPPER_NUMBER));
        divLeft.setAttribute(common_constants_1.BcCommonConstants.ARIA_POSINSET, bc_stepper_constants_9.STEPPER_N3);
        divLeft.appendChild(this._createBulletStepsHeaderNumber());
        divLeft.appendChild(this._createBulletStepsHeaderCircle());
        return divLeft;
    };
    BcStepperBehavior.prototype._createBulletStepsHeaderLeftProgress = function () {
        var divProgressLeft = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divProgressLeft.classList.add("".concat(bc_stepper_constants_1.STEPPER_BAR), common_constants_1.BcCommonConstants.LEFT);
        var divProgress = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divProgress.classList.add("".concat(bc_stepper_constants_5.STEPPER_PROGRESS));
        divProgressLeft.appendChild(divProgress);
        return divProgressLeft;
    };
    BcStepperBehavior.prototype._createBulletStepsHeaderRightProgress = function () {
        var divProgressRight = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divProgressRight.classList.add("".concat(bc_stepper_constants_1.STEPPER_BAR), common_constants_1.BcCommonConstants.RIGHT);
        var divProgressRightProgress = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divProgressRightProgress.classList.add("".concat(bc_stepper_constants_5.STEPPER_PROGRESS));
        divProgressRight.appendChild(divProgressRightProgress);
        return divProgressRight;
    };
    BcStepperBehavior.prototype._createBulletStepsHeaderCircle = function () {
        var divCircle = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divCircle.classList.add("".concat(bc_stepper_constants_3.STEPPER_CIRCLE));
        divCircle.appendChild(this._createBulletStepsHeaderLeftProgress());
        divCircle.appendChild(this._createBulletStepsHeaderRightProgress());
        return divCircle;
    };
    BcStepperBehavior.prototype._createBulletStepsHeaderNumber = function () {
        var divNumber = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divNumber.classList.add("".concat(bc_stepper_constants_12.STEPPER_NUMBER));
        divNumber.id = "".concat(bc_stepper_constants_12.STEPPER_NUMBER);
        divNumber.innerHTML = "".concat(this.currentStep + common_constants_1.COMMON_CONSTANTS_NUMBERS.N1, " de ").concat(this.maxStep);
        return divNumber;
    };
    BcStepperBehavior.prototype._createBulletStepsHeaderCenter = function () {
        var divCenter = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divCenter.classList.add("".concat(bc_stepper_constants_2.STEPPER_HEADER_CENTER));
        divCenter.appendChild(this._createBulletStepsHeaderCenterH6());
        divCenter.appendChild(this._createBulletStepsHeaderCenterP());
        return divCenter;
    };
    BcStepperBehavior.prototype._createBulletStepsHeaderCenterP = function () {
        var elementP = document.createElement(common_constants_1.BcCommonConstants.P_TAG);
        elementP.setAttribute(common_constants_1.BcCommonConstants.TABINDEX, bc_stepper_constants_10.STEPPER_N0);
        elementP.setAttribute(common_constants_1.BcCommonConstants.ARIA_POSINSET, bc_stepper_constants_10.STEPPER_N2);
        elementP.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, bc_stepper_constants_13.STEPPER_SIGUIENTE);
        elementP.innerHTML = "Siguiente: ".concat(this.labels[this.currentStep + common_constants_1.COMMON_CONSTANTS_NUMBERS.N1]);
        return elementP;
    };
    BcStepperBehavior.prototype._createBulletStepsHeaderCenterH6 = function () {
        var elementH6 = document.createElement(common_constants_1.BcCommonConstants.H6_TAG);
        elementH6.setAttribute(common_constants_1.BcCommonConstants.TABINDEX, bc_stepper_constants_10.STEPPER_N0);
        elementH6.setAttribute(common_constants_1.BcCommonConstants.ARIA_POSINSET, bc_stepper_constants_10.STEPPER_N1);
        elementH6.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, bc_stepper_constants_13.STEPPER_ACTUAL);
        elementH6.innerHTML = this.labels[this.currentStep];
        return elementH6;
    };
    BcStepperBehavior.prototype._createBulletStepsHeaderRight = function () {
        var divRight = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divRight.classList.add("".concat(bc_stepper_constants_12.STEPPER_HEADER_RIGHT));
        divRight.setAttribute(common_constants_1.BcCommonConstants.TABINDEX, bc_stepper_constants_10.STEPPER_N0);
        divRight.setAttribute(common_constants_1.BcCommonConstants.ARIA_POSINSET, bc_stepper_constants_10.STEPPER_N4);
        divRight.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, bc_stepper_constants_13.STEPPER_MESSAGE);
        divRight.appendChild(this._createBulletStepsHeaderRightEm());
        return divRight;
    };
    BcStepperBehavior.prototype._createBulletStepsHeaderRightEm = function () {
        var em = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        em.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS);
        em.setAttribute(bc_stepper_constants_13.STEPPER_ATTRIBUTE_ALT, bc_stepper_constants_13.STEPPER_ATTRIBUTE_ARROW_DOWN);
        em.innerHTML = common_constants_1.BcCommonConstants.ICON_ARROW_DOWN;
        return em;
    };
    BcStepperBehavior.prototype.settingAtributes = function () {
        var _this = this;
        var stepperBulletColor = '';
        var _loop_1 = function (i) {
            var bulletChild = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
            bulletChild.classList.add(bc_stepper_constants_2.STEPPER_PROGRESS_STEP);
            bulletChild.setAttribute(common_constants_1.BcCommonConstants.ROLE, common_constants_1.BcCommonConstants.TAB_TAG);
            bulletChild.setAttribute(common_constants_1.BcCommonConstants.ARIA_POSINSET, i.toString());
            bulletChild.setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, bc_stepper_constants_11.STEPPER_FALSE);
            if (this_1.themeCircles == ThemeCircles.DARK) {
                stepperBulletColor = bc_stepper_constants_4.STEPPER_INNER_BULLET_ACTIVE;
            }
            else {
                stepperBulletColor = bc_stepper_constants_4.STEPPER_INNER_BULLET_ACTIVE_LIGHT;
            }
            bulletChild.appendChild(this_1._bulletSteps());
            bulletChild.appendChild(this_1._bulletStepsColor(stepperBulletColor));
            bulletChild.appendChild(this_1._bulletStepsNumber(i));
            bulletChild.appendChild(this_1._bulletStepsStatus());
            bulletChild.appendChild(this_1._bulletStepsLabel(i));
            this_1.mySelf.appendChild(bulletChild);
            var bulletItem = bulletChild.querySelector(".".concat(bc_stepper_constants_3.STEPPER_INNER_BULLET));
            (0, helpers_1.addFocusable)(bulletItem, null, { event: function (event) { return _this.eventClickBullet(i - 1, event); } });
        };
        var this_1 = this;
        for (var i = 1; i <= this.labels.length; i++) {
            _loop_1(i);
        }
    };
    BcStepperBehavior.prototype._bulletSteps = function () {
        var sectionBullet = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionBullet.classList.add(bc_stepper_constants_3.STEPPER_INNER_BULLET);
        return sectionBullet;
    };
    BcStepperBehavior.prototype._bulletStepsColor = function (stepperBulletColor) {
        var sectionColor = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionColor.classList.add(stepperBulletColor);
        return sectionColor;
    };
    BcStepperBehavior.prototype._bulletStepsNumber = function (i) {
        var labelNumber = document.createElement(common_constants_1.BcCommonConstants.LABEL_TAG);
        labelNumber.classList.add(bc_stepper_constants_3.STEPPER_INNER_NUMBER);
        labelNumber.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, bc_stepper_constants_11.STEPPER_TRUE);
        labelNumber.innerHTML = i;
        return labelNumber;
    };
    BcStepperBehavior.prototype._bulletStepsStatus = function () {
        var sectionStatus = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionStatus.classList.add(bc_stepper_constants_5.STEPPER_STATUS);
        var em = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        em.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS);
        em.setAttribute(bc_stepper_constants_13.STEPPER_ATTRIBUTE_ALT, bc_stepper_constants_14.STEPPER_COMPLETE);
        em.innerHTML = bc_stepper_constants_14.STEPPER_OK;
        sectionStatus.appendChild(em);
        return sectionStatus;
    };
    BcStepperBehavior.prototype._bulletStepsLabel = function (i) {
        var sectionLabel = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionLabel.classList.add(bc_stepper_constants_5.STEPPER_LABEL);
        sectionLabel.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, bc_stepper_constants_11.STEPPER_TRUE);
        var label = document.createElement(common_constants_1.BcCommonConstants.LABEL_TAG);
        label.innerHTML = this.labels[i - 1];
        sectionLabel.appendChild(label);
        return sectionLabel;
    };
    BcStepperBehavior.prototype._accessibility = function () {
        var _this = this;
        this.mySelf.querySelectorAll("*[class*=\"".concat(bc_stepper_constants_2.STEPPER_PROGRESS_STEP, "\"]")).forEach(function (element, index) {
            (0, helpers_1.addFocusable)(element, { tabindex: bc_stepper_constants_10.STEPPER_N0 }, { event: function () { return _this.decide(element, index); } });
            _this.screenReader(element, index);
        });
        var arrowHeader = this.mySelf.querySelector(".".concat(bc_stepper_constants_12.STEPPER_HEADER_RIGHT));
        (0, helpers_1.addFocusable)(arrowHeader, {}, { event: function () { return _this.openSteps(arrowHeader); } });
    };
    BcStepperBehavior.prototype.openSteps = function (element) {
        element.click();
    };
    BcStepperBehavior.prototype.decide = function (element, index) {
        if (element.classList.contains(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT)) {
            if (index === this.currentStep + common_constants_1.COMMON_CONSTANTS_NUMBERS.N1) {
                this.next();
            }
            else if (index === this.currentStep - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1) {
                this.back();
            }
        }
    };
    BcStepperBehavior.prototype.screenReader = function (element, index) {
        var _this = this;
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
                _this.focusNext(index);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_LEFT) {
                _this.focusBack(index);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_HOME) {
                _this.focusHomeEnd(index, true);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_END) {
                _this.focusHomeEnd(index);
            }
        });
    };
    BcStepperBehavior.prototype.focusHomeEnd = function (index, key) {
        if (key === void 0) { key = false; }
        if (this._getCurrentElement(index) !== null) {
            this._getCurrentElement(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (key) {
                index = this.initialStep;
            }
            else {
                index = this.labels.length - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1;
            }
            this._getCurrentElement(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this._getCurrentElement(index).focus();
        }
    };
    BcStepperBehavior.prototype.focusNext = function (index) {
        if (this._getCurrentElement(index) !== null) {
            this._getCurrentElement(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (index < this.labels.length - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1) {
                index++;
            }
            else {
                index = this.initialStep;
            }
            this._getCurrentElement(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this._getCurrentElement(index).focus();
            this._getStatus(index);
        }
    };
    BcStepperBehavior.prototype.focusBack = function (index) {
        if (this._getCurrentElement(index) !== null) {
            this._getCurrentElement(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (index > common_constants_1.COMMON_CONSTANTS_NUMBERS.N0) {
                index--;
            }
            else {
                index = this.labels.length - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1;
            }
            this._getCurrentElement(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this._getCurrentElement(index).focus();
            this._getStatus(index);
        }
    };
    BcStepperBehavior.prototype._getStatus = function (index) {
        if (this.status[index] === bc_stepper_constants_7.STEPPER_IS_ACTIVE) {
            this.currentStep = index;
        }
    };
    BcStepperBehavior.prototype._getCurrentElement = function (index) {
        return this.mySelf.querySelectorAll("*[class*=\"".concat(bc_stepper_constants_2.STEPPER_PROGRESS_STEP, "\"]"))[index];
    };
    BcStepperBehavior.prototype.progressHorizontal = function () {
        var currentStepStr = this.currentStep.toString();
        var currentStep = this.currentStep + 1;
        if (currentStep >= this.status.length - 1) {
            this.progressTrack.style.width =
                typeof this.currentStep === bc_stepper_constants_14.STEPPER_STRING && this.currentStep != 0
                    ? this.commonProgress(this.width, currentStepStr, 0)
                    : this.commonProgress(this.width, currentStepStr, 1);
        }
    };
    BcStepperBehavior.prototype.progressVertical = function () {
        var currentStepStr = this.currentStep.toString();
        this.progressTrack.style.height =
            typeof this.currentStep === bc_stepper_constants_14.STEPPER_STRING && this.currentStep != 0
                ? this.commonProgress(this.height, currentStepStr, 0)
                : this.commonProgress(this.height, currentStepStr, 1);
    };
    BcStepperBehavior.prototype.commonProgress = function (size, currentStep, step) {
        var result = size * (parseInt(currentStep) + step) + bc_stepper_constants_14.STEPPER_PORCENTAJE;
        if (result == bc_stepper_constants_14.STEPPER_200_PORCENT) {
            return bc_stepper_constants_14.STEPPER_100_PORCENT;
        }
        else {
            return result;
        }
    };
    BcStepperBehavior.prototype.setIndexStatus = function () {
        var maxLength = this.currentStep;
        for (var index = 0; index < maxLength; index++) {
            this.next(index, false);
        }
    };
    BcStepperBehavior.prototype.next = function (index, notify) {
        if (index === void 0) { index = this.currentStep; }
        if (notify === void 0) { notify = true; }
        if (index < this.labels.length - 1) {
            this.status[index] = bc_stepper_constants_7.STEPPER_IS_COMPLETE;
            index++;
            if (index > this.maxStep) {
                this.maxStep = index;
            }
            this.status[index] = bc_stepper_constants_7.STEPPER_IS_ACTIVE;
            if (this.direction === bc_stepper_constants_8.STEPPER_HORIZONTAL_DIRECTION) {
                this.progressHorizontal();
            }
            else {
                this.progressVertical();
            }
            this._setBulletStatus();
        }
        if (notify) {
            this._setCurrentStep(index);
        }
        else {
            this.currentStep = index;
        }
        this._setProgressHeader();
        this._setCurrentStepHeader();
    };
    BcStepperBehavior.prototype.back = function () {
        if (this.currentStep > 0) {
            this.status[this.currentStep] = bc_stepper_constants_7.STEPPER_IS_DEFAULT;
            this._setCurrentStep(this.currentStep - 1);
            this.status[this.currentStep] = bc_stepper_constants_7.STEPPER_IS_ACTIVE;
            this._setBulletStatus();
            this._setProgressHeader();
            this._setCurrentStepHeader();
        }
    };
    BcStepperBehavior.prototype._setBulletStatus = function () {
        var _this = this;
        this.status.forEach(function (element, index) {
            var defaultCase = function () {
                _this.progressBulletArray[index].classList.remove(bc_stepper_constants_6.STEPPER_ACTIVE_STEP, bc_stepper_constants_6.STEPPER_COMPLETE_STEP);
                _this.progressBulletArray[index].classList.add(bc_stepper_constants_6.STEPPER_DEFAULT_STEP);
                _this.progressStepArray[index].classList.remove(bc_stepper_constants_6.STEPPER_ACTIVE_STEP, bc_stepper_constants_6.STEPPER_COMPLETE_STEP);
            };
            switch (element) {
                case bc_stepper_constants_7.STEPPER_IS_ACTIVE:
                    _this.progressBulletArray[index].classList.remove(bc_stepper_constants_6.STEPPER_DEFAULT_STEP, bc_stepper_constants_6.STEPPER_COMPLETE_STEP);
                    _this.progressBulletArray[index].classList.add(bc_stepper_constants_6.STEPPER_ACTIVE_STEP);
                    _this.progressStepArray[index].classList.add(bc_stepper_constants_6.STEPPER_ACTIVE_STEP);
                    _this.progressStepArray[index].setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, bc_stepper_constants_11.STEPPER_TRUE);
                    break;
                case bc_stepper_constants_7.STEPPER_IS_DEFAULT:
                    defaultCase();
                    break;
                case bc_stepper_constants_7.STEPPER_IS_COMPLETE:
                    _this.progressBulletArray[index].classList.remove(bc_stepper_constants_6.STEPPER_ACTIVE_STEP, bc_stepper_constants_6.STEPPER_DEFAULT_STEP);
                    _this.progressBulletArray[index].classList.add(bc_stepper_constants_6.STEPPER_COMPLETE_STEP);
                    _this.progressStepArray[index].classList.remove(bc_stepper_constants_6.STEPPER_ACTIVE_STEP, bc_stepper_constants_6.STEPPER_DEFAULT_STEP);
                    _this.progressStepArray[index].setAttribute(common_constants_1.BcCommonConstants.ARIA_SELECTED, bc_stepper_constants_11.STEPPER_FALSE);
                    break;
                default:
                    defaultCase();
            }
        });
    };
    BcStepperBehavior.prototype._setCurrentStep = function (index) {
        this.currentStep = index;
        if (this.outputFunction) {
            this.outputFunction(index);
        }
    };
    BcStepperBehavior.prototype._getCurrentState = function () {
        return this.currentStep;
    };
    BcStepperBehavior.prototype._setProgressHeader = function () {
        this.progressHeader = ((this.currentStep + 1) / this.maxStep) * bc_stepper_constants_9.STEPPER_N100;
        var progressDeg = (bc_stepper_constants_9.STEPPER_N360 * this.progressHeader) / bc_stepper_constants_9.STEPPER_N100;
        if (this.progressHeader < bc_stepper_constants_9.STEPPER_N50) {
            this.mySelf.querySelector(".".concat(bc_stepper_constants_5.STEPPER_HEADER_LEFT, " .").concat(common_constants_1.BcCommonConstants.LEFT, " .").concat(bc_stepper_constants_5.STEPPER_PROGRESS))[common_constants_1.BcCommonConstants.STYLE].transform =
                'rotate(' + progressDeg + 'deg)';
            this.mySelf.querySelector(".".concat(bc_stepper_constants_5.STEPPER_HEADER_LEFT, " .").concat(common_constants_1.BcCommonConstants.RIGHT, " .").concat(bc_stepper_constants_5.STEPPER_PROGRESS))[common_constants_1.BcCommonConstants.STYLE].transform =
                'rotate(0deg)';
        }
        else {
            this.mySelf.querySelector(".".concat(bc_stepper_constants_5.STEPPER_HEADER_LEFT, " .").concat(common_constants_1.BcCommonConstants.LEFT, " .").concat(bc_stepper_constants_5.STEPPER_PROGRESS))[common_constants_1.BcCommonConstants.STYLE].transform =
                'rotate(180deg)';
            this.mySelf.querySelector(".".concat(bc_stepper_constants_5.STEPPER_HEADER_LEFT, " .").concat(common_constants_1.BcCommonConstants.RIGHT, " .").concat(bc_stepper_constants_5.STEPPER_PROGRESS))[common_constants_1.BcCommonConstants.STYLE].transform =
                'rotate(' + (progressDeg - bc_stepper_constants_9.STEPPER_N180) + 'deg)';
        }
        this.mySelf.querySelector(".".concat(bc_stepper_constants_5.STEPPER_HEADER_LEFT, " .").concat(bc_stepper_constants_12.STEPPER_NUMBER)).innerHTML = "".concat(this.currentStep + 1, " de ").concat(this.maxStep);
    };
    BcStepperBehavior.prototype._setCurrentStepHeader = function () {
        var currentStep = this.labels[this.currentStep];
        var nextStep = this.labels[this.currentStep + 1] ? "Siguiente: ".concat(this.labels[this.currentStep + 1]) : '';
        this.mySelf.querySelector(".".concat(bc_stepper_constants_2.STEPPER_HEADER_CENTER, " > ").concat(common_constants_1.BcCommonConstants.H6_TAG)).innerHTML = currentStep;
        this.mySelf.querySelector(".".concat(bc_stepper_constants_2.STEPPER_HEADER_CENTER, " > ").concat(common_constants_1.BcCommonConstants.P_TAG)).innerHTML = nextStep;
    };
    BcStepperBehavior.prototype.addClickEventHeader = function () {
        var _this = this;
        this.mySelf
            .querySelector(".".concat(bc_stepper_constants_12.STEPPER_HEADER_RIGHT))
            .addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            event.target['classList'].toggle('active');
            var isExpanded = _this.mySelf.getAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED) === bc_stepper_constants_11.STEPPER_TRUE ? bc_stepper_constants_11.STEPPER_FALSE : bc_stepper_constants_11.STEPPER_TRUE;
            _this.mySelf.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, isExpanded);
            var elements = _this.mySelf.querySelectorAll("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_stepper_constants_2.STEPPER_PROGRESS_STEP));
            elements.forEach(function (e) {
                e.classList.toggle('hidden-step');
                isExpanded === bc_stepper_constants_11.STEPPER_TRUE ? e.setAttribute(common_constants_1.BcCommonConstants.TABINDEX, bc_stepper_constants_10.STEPPER_N0) : e.setAttribute(common_constants_1.BcCommonConstants.TABINDEX, '-1');
            });
        });
    };
    BcStepperBehavior.prototype.scrollEventHeader = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_SCROLL, function () {
            if (_this.topHeader >= 0) {
                _this._setIsTopClass();
            }
        });
    };
    BcStepperBehavior.prototype._setIsTopClass = function () {
        var _this = this;
        var rect = this.mySelf.getBoundingClientRect();
        var elemTop = rect.top;
        if (elemTop === this.topHeader && !this.isTop) {
            setTimeout(function () {
                _this.mySelf.querySelector(common_constants_1.BcCommonConstants.HEADER_TAG).classList.add(bc_stepper_constants_1.STEPPER_IS_TOP_CLASS);
            });
            this.isTop = true;
            return;
        }
        if (elemTop > this.topHeader && this.isTop) {
            this.mySelf.querySelector(common_constants_1.BcCommonConstants.HEADER_TAG).classList.remove(bc_stepper_constants_1.STEPPER_IS_TOP_CLASS);
            this.isTop = false;
        }
    };
    return BcStepperBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcStepperBehavior = BcStepperBehavior;
